import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "upload_body_nr"
};
const _hoisted_3 = {
  class: "upload_list"
};
const _hoisted_4 = {
  key: 0,
  style: {
    "width": "347px"
  },
  src: "https://www.mimodental.com/assets/imgData/img/member_preferential/empty.png"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "img_div"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "text"
};
const _hoisted_9 = {
  style: {
    "margin-bottom": "20px",
    "display": "flex",
    "align-items": "center",
    "flex-wrap": "wrap"
  }
};
const _hoisted_10 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/new/top.png",
  style: {
    "width": "50px",
    "object-fit": "cover",
    "margin-left": "30px"
  }
};
const _hoisted_11 = {
  style: {
    "display": "block",
    "text-indent": "32px"
  }
};
const _hoisted_12 = {
  style: {
    "color": "#999"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("h1", null, "媒体报道", -1)), _createElementVNode("div", _hoisted_3, [$setup.upList.length == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.go(item.id)
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
      src: item.imgUrl,
      alt: ""
    }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_9, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.topSort ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_11, _toDisplayString(item.brief), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(item.customTime), 1)]), _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "item_r_b"
    }, [_createElementVNode("span", null, "了解详情")], -1))])], 8, _hoisted_5);
  }), 128))])])]);
}